"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyEffect_OnAllyResurrectedEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let ApplyEffect_OnAllyResurrectedEventHandlerScript = class ApplyEffect_OnAllyResurrectedEventHandlerScript {
    run(sequence, container, handler, event) {
        const { applyTo, effects } = handler.args.scriptArgs;
        const targetId = applyTo === "resurrected" ? event.args.allyId
            : false;
        if (targetId === false) {
            return;
        }
        effects
            .filter(({ percentChance = 100 }) => percentChance >= 100 || (0, Random_1.random)(1, 100) <= percentChance)
            .forEach(({ effect, duration, supernatural = false }) => {
            if (effect.harmful) {
                container.applyDebuff({
                    sequence,
                    attackerId: event.subject,
                    targetId,
                    duration,
                    effect,
                    supernatural
                });
            }
            else {
                container.applyBuff({
                    sequence,
                    creatorId: event.subject,
                    targetId,
                    duration,
                    effect,
                    supernatural
                });
            }
        });
    }
};
ApplyEffect_OnAllyResurrectedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("ApplyEffect_OnAllyResurrected")
], ApplyEffect_OnAllyResurrectedEventHandlerScript);
exports.ApplyEffect_OnAllyResurrectedEventHandlerScript = ApplyEffect_OnAllyResurrectedEventHandlerScript;
